import { render, staticRenderFns } from "./acceptBuddy.vue?vue&type=template&id=03240740&"
import script from "./acceptBuddy.vue?vue&type=script&lang=js&"
export * from "./acceptBuddy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports